import { render, staticRenderFns } from "./TestCustomDraggingList.vue?vue&type=template&id=a8fb01be&scoped=true"
import script from "./TestCustomDraggingList.vue?vue&type=script&lang=js"
export * from "./TestCustomDraggingList.vue?vue&type=script&lang=js"
import style0 from "./TestCustomDraggingList.vue?vue&type=style&index=0&id=a8fb01be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fb01be",
  null
  
)

export default component.exports